<template>
  <div class="menu-movil" id="menu-movil">
    <div class="menu-movil-cerrar">
      <i
        class="fas fa-times icono-cerrar-menu"
        @click.prevent="CerrarMenu()"
      ></i>
    </div>
    <div class="menu-movil__usuario">
      <i class="fas fa-user-tie"></i>
      <div class="text-start">
        <label>
          {{
            NombreUsuario + " " + ApellidoUsuario
          }}
        </label>
      </div>
    </div>
    <div class="contenedor-opciones">
      <label
        v-if="TipoUsuario == 1 || TipoUsuario == 6 || TipoUsuario == 9"
        @click.prevent="NavegarACalendario"
        >Calendario</label
      >
      <label
        v-if="
          TipoUsuario == 1 ||
            TipoUsuario == 4 ||
            TipoUsuario == 5 ||
            TipoUsuario == 6 ||
            TipoUsuario == 8 ||
            TipoUsuario == 9 ||
            TipoUsuario == 10
        "
        @click.prevent="Navegar"
        >Prospectos</label
      >
      <label
        v-if="TipoUsuario == 5 || TipoUsuario == 6 || TipoUsuario == 8 || TipoUsuario == 9 || TipoUsuario == 10"
        @click.prevent="$router.push({ path: 'AdministracionDeClientes' })"
        >Clientes</label
      >
      <label
        v-if="TipoUsuario == 4 || TipoUsuario == 5 || TipoUsuario == 6 || TipoUsuario == 8 || TipoUsuario == 9 || TipoUsuario == 10"
        @click.prevent="$router.push({ path: 'AdministracionDePendientes' })"
        >Pausados / Cancelados</label
      >
      <label
        v-if="
          TipoUsuario == 1 ||
            TipoUsuario == 4 ||
            TipoUsuario == 5 ||
            TipoUsuario == 6 ||
            TipoUsuario == 7 ||
            TipoUsuario == 8 ||
            TipoUsuario == 9 ||
            TipoUsuario == 10 ||
            TipoUsuario == 11
        "
        @click.prevent="NavegarABiblioteca"
        >Biblioteca Virtual</label
      >
      
      <label
        v-if=" TipoUsuario == 11 "
        @click.prevent="NavegarABibliotecaAdmin"
        >Administrador Biblioteca Virtual</label
      >

      <label
        v-if="
          (TipoUsuario == 3 &&
            $store.getters.avisoPrivacidadAceptado)
        "
        @click.prevent="NavegarContratos"
      >
        {{
          this.TipoPersona == 2 ||
          this.TipoPersona == 5 ||
          this.TipoPersona == 7
            ? "Welcome Kit"
            : "Kit de Bienvenida"
        }}
      </label>
      <label
        v-if="TipoUsuario == 3 && $store.getters.avisoPrivacidadAceptado"
        @click.prevent="Navegar"
      >
        {{
          this.TipoPersona == 2 ||
          this.TipoPersona == 5 ||
          this.TipoPersona == 7
            ? "Tracking"
            : "Seguimiento"
        }}
      </label>
      <label
        v-if="
          TipoUsuario == 1 ||
            TipoUsuario == 6 ||
            TipoUsuario == 7 ||
            TipoUsuario == 8 ||
            TipoUsuario == 9 ||
            TipoUsuario == 10
        "
        @click.prevent="NavegarDashboard"
        >Dashboard</label
      >
      <label
        v-if="
          TipoUsuario == 11 
        "
        @click.prevent="$router.push({ name: 'Administrador' })"
        >Perfiles</label
      >
      <label style="color: #b8725a" @click.prevent="CerrarSesion">
        {{
          TipoPersona == 2 || TipoPersona == 5 || TipoPersona == 7
            ? "Logout"
            : "Cerrar sesión"
        }}
      </label>
    </div>
  </div>
</template>

<script lang="js">
import servicios from '../servicios/service.js';

export default {
  name:"MenuNavegacionMovil",
  data() {
    return {
      TipoUsuario: null,
      NombreUsuario: "",
      ApellidoUsuario: "",
      TipoPersona: null
    }
  },
  created () {
    this.$root.$refs.MenuNavegacionMovil = this;
  },
  mounted () {
    this.ProspectoId = this.$store.getters.prospectoId;
    this.NombreUsuario = sessionStorage.getItem("nombreUsuario");
    this.ApellidoUsuario = sessionStorage.getItem("apellidoUsuario");
    this.TipoUsuario = parseInt(sessionStorage.getItem("tipoUsuario"));
    this.TipoPersona = sessionStorage.getItem("tipoPersona");
  },
  methods: {
    CerrarMenu() {
        document.getElementById("menu-movil").style.width = "0%";
    },
    AbrirMenu() {
        document.getElementById("menu-movil").style.width = "75%";
    },
    Navegar(){
        this.$root.$refs.MenuNavegacion.IrAProspectos();
        this.CerrarMenu();
    },
    NavegarACalendario(){
        this.$router.push({ name: 'Calendario' })
        this.CerrarMenu();
    },
    NavegarABiblioteca(){
        this.$router.push({ name: 'BibliotecaDigital' })
        this.CerrarMenu();
    },
    
    NavegarABibliotecaAdmin(){
        this.$router.push({ name: 'AdministracionBibliotecaDigital' })
        this.CerrarMenu();
    },

     NavegarContratos(){
        this.$router.push({ name: 'CajaDorada' })
        this.CerrarMenu();
    },
      NavegarDashboard(){
        this.$router.push({ name: 'Dashboard2' })
        this.CerrarMenu();
    },
    CerrarSesion() {
      this.$fire({
        title: (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "Are you sure you want to log out?" : "¿Estás seguro que quieres cerrar sesión?",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "Accept" : "Aceptar",
        cancelButtonText: (this.TipoPersona == 2 || this.TipoPersona == 5 || this.TipoPersona == 7) ? "Cancel" : "Cancelar"
      }).then(result => {
        if (result.value) {
          // if(!this.$store.getters.avisoPrivacidadAceptado)
          //   if(this.ProspectoId != null) this.EstablecerPrimerAccesoProspecto(this.ProspectoId);
          servicios.CerrarSesion();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
/*MENU MOVIL */
.menu-movil {
  overflow-x: hidden;
  text-align: center;
  background-size: 100% 5px;
  position: fixed;
  z-index: 2;
  width: 0%;
  transition: 0.5s;
  background-color: #151516;
  height: 100vh;
}
.menu-movil-cerrar {
  height: 10%;
}
.menu-movil__usuario {
  margin-top: 50px;
  padding-left: 40px;
  align-items: center;
  display: flex;
}
.menu-movil__usuario i {
  font-size: 20px;
  color: white;
}
.menu-movil__usuario label {
  color: white;
  margin-left: 15px;
}
.contenedor-opciones {
  padding-top: 10px;
  text-align: left;
}
.contenedor-opciones label {
  color: white;
  font-family: Poppins;
  cursor: pointer;
  display: block;
  font-size: 18px;
  font-weight: 600;
  padding-top: 20px;
  padding-left: 40px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ffffff93;
}
.icono-cerrar-menu {
  color: #c4c4c4;
  font-size: 35px !important;
  float: right;
  padding-right: 20px;
  padding-top: 20px;
}
@media all and (max-width: 767px) {
  .menu-movil {
    display: block;
  }
}
</style>
